import React from 'react';
import Badge from './Badge';
import iconImageBadge from '/img/contact/icons/clay.png?url';
import { ClayUserIcon, ClayUserWithTextIcon } from '@components/Icons';
import Contact from '@models/Contact';

export default function ClayUserBadge({
  contact,
  icon = false,
  image = false,
  ...props
}: {
  contact?: Contact;
  icon?: boolean;
  image?: boolean;
}) {
  if (contact && !contact.isClayUser) {
    return null;
  }

  let IconComponent = ClayUserWithTextIcon;

  if (icon) {
    IconComponent = ClayUserIcon;

    if (image) {
      return <Badge src={iconImageBadge} icon={icon} {...props} />;
    }
  }

  return <IconComponent {...props} />;
}
